_ = require('lodash')

EmailConfirmationService = ($http) ->
  send: ->
    $http.post('/api/email_confirmation/send.json')

  confirm: (token) ->
    $http.post('/api/email_confirmation/confirm.json', token: token)

EmailConfirmationService.$inject = [
  '$http'
]

module.exports = EmailConfirmationService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/email-confirmation/email-confirmation-service.coffee